<div class="question-response-container" [hidden]="labelOnly">
  <mat-form-field class="custom-select">
    <mat-select  
      [formControl]="questionControl" 
      [disabled]="readOnly"
      name="question">
      <mat-option *ngFor="let item of options" [value]="item[value]">
        {{ item[label] }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="question-response-container-label" *ngIf="labelOnly">
  {{ questionControl?.value  }}
</div>